import { render, staticRenderFns } from "./generacionArchivo.vue?vue&type=template&id=2163f989"
import script from "./generacionArchivo.vue?vue&type=script&lang=js"
export * from "./generacionArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports